import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sync-set-success-popup',
  standalone: false,
  templateUrl: './sync-set-success-popup.html',
  styleUrl: './sync-set-success-popup.scss'
})
export class SyncSetSuccessPopup {
  constructor(
    private readonly dialogRef: MatDialogRef<SyncSetSuccessPopup>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}